// Pending-Änderungen im localStorage halten, solange kein Netz da ist.
// Reines Modul ohne DOM-Abhängigkeiten; localStorage kann fehlen oder voll
// sein (Private Mode, Quota) — deshalb überall try/catch.

const PREFIX = "plattenwerk-pending:"

function storageKey(key) {
  return `${PREFIX}${key}`
}

export function savePending(key, { version, payload }) {
  try {
    localStorage.setItem(storageKey(key), JSON.stringify({ version, payload }))
  } catch {
    // Quota voll oder Storage gesperrt — dann eben keine Offline-Kopie
  }
}

export function loadPending(key) {
  try {
    const raw = localStorage.getItem(storageKey(key))
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function clearPending(key) {
  try {
    localStorage.removeItem(storageKey(key))
  } catch {
    // egal — beim nächsten savePending wird eh überschrieben
  }
}

// Lokaler Stand zählt, wenn er auf mindestens der Server-Version basiert.
export function shouldRestore(pending, serverVersion) {
  return Boolean(pending && pending.version >= serverVersion)
}

// Ersetzt parts/camera (und die Basis-Version) im Szenen-JSON durch den
// Pending-Stand, falls dieser neuer oder gleich alt ist. Die Version muss mit,
// sonst würde der nächste Sync mit veralteter base_version im Konflikt enden.
export function restorePendingIntoScene(sceneJson, url) {
  const pending = loadPending(url)
  if (!shouldRestore(pending, sceneJson.version)) {
    return { scene: sceneJson, restored: false }
  }
  return {
    scene: {
      ...sceneJson,
      version: pending.version,
      parts: pending.payload.parts,
      camera: pending.payload.camera
    },
    restored: true
  }
}
